import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import type { DevToolsPlugin } from '../../types';
import { styles } from './pendo.styles';

declare const pendo: { validateEnvironment: () => unknown } | undefined;

@customElement('acme-devtools-pendo')
export class AcmeDevToolsPendo extends LitElement {
  static override styles = styles;

  @state() private validationResult: unknown = null;

  override connectedCallback() {
    super.connectedCallback();
    try {
      this.validationResult = typeof pendo !== 'undefined' ? pendo.validateEnvironment() : null;
    } catch {
      this.validationResult = null;
    }
  }

  override render() {
    if (this.validationResult === null) {
      return html`Pendo not available. <code>pendo.validateEnvironment()</code> could not be called.`;
    }

    return html`<code>${JSON.stringify(this.validationResult, null, 2)}</code>`;
  }
}

export const pendoPlugin: DevToolsPlugin = {
  id: 'pendo',
  label: 'Pendo',
  tagName: 'acme-devtools-pendo',
};

declare global {
  interface HTMLElementTagNameMap {
    'acme-devtools-pendo': AcmeDevToolsPendo;
  }
}
